import { useContext, useEffect, useMemo, useState } from "react";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { fetchgoldenacc } from "../CustSearch/apiSearch";
import { FilterContext } from "../../context/Filter";

const Goldaccdetailstable = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const { superArn: parArn, childArn } = useContext(FilterContext);

    const key = childArn ? "childArn" : "parArn";
    const value = childArn || parArn;
    const payload = { [key]: value };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const records = await fetchgoldenacc(payload);

                const transformedData = [
                    {
                        rowType: "Name",
                        proprietor: records.length > 0 ? `${records[0].KEY_CUST_PROPRIETOR_FIRST_NAME || ""} ${records[0].KEY_CUST_PROPRIETOR_LAST_NAME || ""}`.trim() || "---" : "---",
                        headOfPurchase: records.length > 0 ? records[0].KEY_CUST_HEAD_OF_PURCHASE_NAME || "---" : "---",
                        headOfOperations: records.length > 0 ? records[0].KEY_CUST_HEAD_OF_OPERATIONS_NAME || "---" : "---",
                        headOfService: records.length > 0 ? records[0].KEY_CUST_HEAD_OF_SERVICE_NAME || "---" : "---"
                    },
                    {
                        rowType: "Email ID",
                        proprietor: records.length > 0 ? records[0].KEY_CUST_PROPRIETOR_EMAIL_ID || "---" : "---",
                        headOfPurchase: records.length > 0 ? records[0].KEY_CUST_HEAD_OF_PURCHASE_EMAIL_ID || "---" : "---",
                        headOfOperations: records.length > 0 ? records[0].KEY_CUST_HEAD_OF_OPERATIONS_EMAIL_ID || "---" : "---",
                        headOfService: records.length > 0 ? records[0].KEY_CUST_HEAD_OF_SERVICE_EMAIL_ID || "---" : "---"
                    },
                    {
                        rowType: "Mobile No.",
                        proprietor: records.length > 0 ? records[0].KEY_CUST_PROPRIETOR_MOBILE || "---" : "---",
                        headOfPurchase: records.length > 0 ? records[0].KEY_CUST_HEAD_OF_PURCHASE_MOBILE || "---" : "---",
                        headOfOperations: records.length > 0 ? records[0].KEY_CUST_HEAD_OF_OPERATIONS_MOBILE || "---" : "---",
                        headOfService: records.length > 0 ? records[0].KEY_CUST_HEAD_OF_SERVICE_MOBILE || "---" : "---"
                    },
                    {
                        rowType: "Phone No.",
                        proprietor: records.length > 0 ? records[0].KEY_CUST_PROPRIETOR_PHONE || "---" : "---",
                        headOfPurchase: records.length > 0 ? records[0].KEY_CUST_HEAD_OF_PURCHASE_PHONE || "---" : "---",
                        headOfOperations: records.length > 0 ? records[0].KEY_CUST_HEAD_OF_OPERATIONS_PHONE || "---" : "---",
                        headOfService: records.length > 0 ? records[0].KEY_CUST_HEAD_OF_SERVICE_PHONE || "---" : "---"
                    }
                ];

                setData(transformedData);
            } catch (error) {
                console.error("Error fetching data:", error);
                setData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [parArn, childArn]);

    const columns = useMemo(() => [
        {
            accessorKey: "rowType",
            header: "",
            Cell: ({ row }) => (
                <div style={{ fontWeight: "bold", color: "#1E70B0", textAlign: "center" }}>
                    {row.original.rowType}
                </div>
            ),
            muiTableBodyCellProps: {
                sx: { backgroundColor: "#f8fafc", borderRight: "2px solid #e2e8f0", height: "70px", display: "flex", alignItems: "center", justifyContent: "center" }
            },
            size: 100
        },
        {
            accessorKey: "proprietor",
            header: "Proprietor",
            muiTableBodyCellProps: { sx: { height: "70px", display: "flex", alignItems: "center", padding: "12px 8px" } }
        },

        {
            accessorKey: "headOfPurchase",
            header: "Head of Purchase",
            muiTableBodyCellProps: { sx: { height: "70px", display: "flex", alignItems: "center", padding: "12px 8px" } }
        },
        {
            accessorKey: "headOfOperations",
            header: "Head of Operations",
            muiTableBodyCellProps: { sx: { height: "70px", display: "flex", alignItems: "center", padding: "12px 8px" } }
        },
        {
            accessorKey: "headOfService",
            header: "Head of Service",
            muiTableBodyCellProps: { sx: { height: "70px", display: "flex", alignItems: "center", padding: "12px 8px" } }
        },
    ], []);

    const table = useMaterialReactTable({
        columns,
        data,
        state: { isLoading: loading },
        enableColumnResizing: true,
        enableSorting: false,
        enableColumnFilters: false,
        enableGlobalFilter: false,
        enablePagination: false,
        muiTableHeadRowProps: { sx: { backgroundColor: "#1E70B0" } },
        muiTableHeadCellProps: { sx: { color: "white", fontWeight: "bold", fontSize: "0.95rem" } },
        muiTableContainerProps: {
            sx: {
                maxHeight: "250px",
                overflowY: "auto",
                overflowX: "auto"
            }
        }
    });

    return (
        <div className="p-4">
            <MaterialReactTable table={table} />
            {!loading && data.length === 0 && (
                <div className="text-center text-gray-500">No Data Found</div>
            )}
        </div>
    );
};

export default Goldaccdetailstable;
